/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_BodyInputs */

const en_why_listening_zotero_body = /** @type {(inputs: Why_Listening_Zotero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect once and import the papers you want to hear.`)
};

const es_why_listening_zotero_body = /** @type {(inputs: Why_Listening_Zotero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctala una vez e importa los artículos que quieras escuchar.`)
};

/**
* | output |
* | --- |
* | "Connect once and import the papers you want to hear." |
*
* @param {Why_Listening_Zotero_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_body = /** @type {((inputs?: Why_Listening_Zotero_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_body(inputs)
	return en_why_listening_zotero_body(inputs)
});